import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import I18nContext from '../../_context';
import { normalizeNamespaces, hasLoadedNamespace, loadNamespaces } from './_helpers';
export var DEFAULT_OPTIONS = {
  useSuspense: false,
  bindI18n: ['languageChanged'],
  bindStore: [],
  nsMode: 'default'
};

var useTranslate = function useTranslate(namespaces, options) {
  var i18n = React.useContext(I18nContext);

  var _namespaces = normalizeNamespaces(i18n, namespaces);

  var _options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var _namespacesSignature = _namespaces.sort().join(',');

  var ready = i18n.isInitialized && _namespaces.every(function (ns) {
    return hasLoadedNamespace(ns, i18n);
  });

  var _getTranslateFn = React.useMemo(function () {
    return function () {
      var __namespaces = _namespaces;

      if (_options.nsMode === 'default') {
        __namespaces = Array.isArray(__namespaces) ? __namespaces[0] : __namespaces;
      }

      return {
        current: i18n.getFixedT(null, __namespaces)
      };
    };
  }, [i18n, _namespacesSignature, _options.nsMode]);

  var _React$useState = React.useState(_getTranslateFn()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      translateFn = _React$useState2[0],
      setTranslateFn = _React$useState2[1];

  React.useEffect(function () {
    if (ready || _options.useSuspense) {
      return undefined;
    }

    var isMounted = true;
    loadNamespaces(i18n, _namespaces).finally(function () {
      if (isMounted) {
        setTranslateFn(_getTranslateFn());
      }
    });
    return function () {
      isMounted = false;
    };
  }, [i18n, _namespacesSignature, _getTranslateFn]);
  var bindI18n = _options.bindI18n,
      bindStore = _options.bindStore;
  React.useEffect(function () {
    if (!ready) {
      return undefined;
    }

    var isMounted = true;

    var handleI18nChanged = function handleI18nChanged() {
      if (!isMounted) {
        return;
      }

      setTranslateFn(_getTranslateFn());
    };

    if (bindI18n.length) {
      i18n.on(bindI18n.join(' '), handleI18nChanged);
    }

    if (bindStore.length && i18n.store) {
      i18n.store.on(bindStore.join(' '), handleI18nChanged);
    }

    return function () {
      isMounted = false;

      if (bindI18n.length) {
        bindI18n.forEach(function (event) {
          i18n.off(event, handleI18nChanged);
        });
      }

      if (bindStore.length && i18n.store) {
        var store = i18n.store;
        bindStore.forEach(function (event) {
          store.off(event, handleI18nChanged);
        });
      }
    };
  }, [ready, bindI18n, bindStore, i18n, _getTranslateFn]);

  if (ready || !ready && !_options.useSuspense) {
    return {
      __: translateFn.current,
      i18n: i18n,
      ready: ready
    };
  }

  throw new Promise(function (resolve) {
    loadNamespaces(i18n, _namespaces).finally(function () {
      setTranslateFn(_getTranslateFn());
      resolve();
    });
  });
};

export default useTranslate;